import React from 'react';
import { Switch } from 'react-router-dom';
import Route from '~/routes/routes';
import Blacklists from '~/views/blacklists';
import Companies from '~/views/companies';
import DashboardSupplier from '~/views/dashboard-supplier';
import EmailsTemplate from '~/views/emails-template';
import Events from '~/views/events';
import EventAccredit from '~/views/events/accredit';
import EventAccreditApproval from '~/views/events/accredit-approval';
import EventCreateOrUpdate from '~/views/events/create-update';
import EventMatchday from '~/views/events/matchday';
import EventTypes from '~/views/event-types';
import Forbidden from '~/views/forbidden';
import Home from '~/views/home';
import Landing from '~/views/landing';
import LandingPress from '~/views/landing-press';
import Persons from '~/views/persons';
import Places from '~/views/places';
import Profiles from '~/views/profiles';
import Roles from '~/views/roles';
import Users from '~/views/users';
import MatchDay from '~/views/match-day';
import Checkout from '~/views/checkout';
import ReportEvent from '~/views/report-event';

export default function Routes() {
  return (
    <Switch>
      <Route path='/' exact component={Landing} />
      <Route path='/imprensa' exact component={LandingPress} />
      <Route path='/forbidden' component={Forbidden} />

      <Route path='/home' component={Home} isPrivate />
      <Route path='/dashboard-supplier' component={DashboardSupplier} isPrivate />

      <Route path='/users' component={Users} isPrivate />
      <Route path='/profiles' component={Profiles} isPrivate />

      <Route path='/persons' component={Persons} isPrivate />
      <Route path='/roles' component={Roles} isPrivate />
      
      <Route path='/companies' component={Companies} isPrivate />
      <Route path='/event-types' exact component={EventTypes} isPrivate />
      <Route path='/places' exact component={Places} isPrivate />

      <Route path='/events' exact component={Events} isPrivate />
      <Route path='/events/accredit/:id' component={EventAccredit} isPrivate />
      <Route path='/events/accredit-approval/:id' component={EventAccreditApproval} isPrivate />
      <Route path='/events/:mode/:id' component={EventMatchday} isPrivate />
      <Route path='/events/:id' component={EventCreateOrUpdate} isPrivate />
      
      <Route path='/blacklists' component={Blacklists} isPrivate />
      <Route path='/emails-template' component={EmailsTemplate} isPrivate />
      <Route path='/report-event' component={ReportEvent} isPrivate />

      <Route path='/match-day' component={MatchDay} isPrivate />
      <Route path='/checkout' component={Checkout} isPrivate />

      <Route component={Forbidden} />
    </Switch>
  );
}
